import React from "react"
import "./frames.css"

const Sigma40 = () => {
  return (
    <div className="frames-container">
      <h1 className="frames-title">
        Modelo Sigma 40: Redefiniendo la Comodidad en Tratamientos Hiperbáricos
      </h1>

      <h2 className="frames-subtitle">
        Espacio sin Precedentes: La Cámara Monoplaza Más Grande del Mundo
      </h2>

      <p className="frames-text">
        Como líder en la industria de las cámaras hiperbáricas, Perry presenta
        con orgullo su modelo insignia, la SIGMA 40. Esta cámara monoplaza no
        solo es parte de nuestro portfolio de vanguardia, sino que también es
        reconocida como el modelo con el diámetro de metacrilato interior más
        grande en servicio actualmente.
      </p>

      <h2 className="frames-subtitle">Medidas que Marcan la Diferencia</h2>

      <p className="frames-text">
        La SIGMA 40 tiene un impresionante diámetro interno de 102.90 cm (40,5
        pulgadas), equivalente a la altura de un niño de 5 años. Este espacio
        interior sin parangón, complementado con una total transparencia del
        habitáculo, minimiza significativamente las complicaciones en el
        tratamiento que podrían surgir debido a la claustrofobia o ansiedad del
        paciente.
      </p>

      <h2 className="frames-subtitle">
        Ampliando Horizontes: Tratamiento Inclusivo para Todas las Estaturas
      </h2>

      <p className="frames-text">
        Este diámetro interno no solo hace que la experiencia sea más cómoda
        para el paciente, sino que también abre puertas a tratamientos
        especializados para la población bariátrica y personas de gran tallaje,
        como los jugadores de baloncesto. La SIGMA 40 puede acomodar pacientes
        de hasta 300 kg y de una altura de 2,20 metros.
      </p>

      <h2 className="frames-subtitle">
        Innovación en Diseño: Mayor Espacio, Menor Peso
      </h2>

      <p className="frames-text">
        Mientras que el diámetro interno de la cámara ha visto un aumento
        significativo, nuestra adopción de nuevas tecnologías en la construcción
        ha permitido una disminución en el peso total de la SIGMA 40 en 1.293
        kg. Esto resulta en menos restricciones para la instalación, superando
        los desafíos que presentan las limitaciones de peso en infraestructuras
        más antiguas.
      </p>

      <p className="frames-text">
        Esta combinación de un espacio interior sin precedentes, junto con
        nuestra atención a la comodidad y seguridad del paciente, hace de la
        SIGMA 40 una opción incomparable para quienes buscan lo mejor en
        tratamientos hiperbáricos.
      </p>
    </div>
  )
}

export default Sigma40
